export enum TaxCouponItemIcmsOrigin {
  NATIONAL_EXCEPT_CODES_3458 = 'NATIONAL_EXCEPT_CODES_3458',
  FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6 = 'FOREIGN_DIRECT_IMPORT_EXCEPT_CODE_6',
  FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7 = 'FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_EXCEPT_CODE_7',
  NATIONAL_CONTENT_IMPORTATION_40_70 = 'NATIONAL_CONTENT_IMPORTATION_40_70',
  NATIONAL_BASIC_PRODUCTION_PROCESS = 'NATIONAL_BASIC_PRODUCTION_PROCESS',
  NATIONAL_CONTENT_IMPORTATION_40 = 'NATIONAL_CONTENT_IMPORTATION_40',
  FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX = 'FOREIGN_DIRECT_IMPORT_NO_NATIONAL_SIMILAR_CAMEX',
  FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX = 'FOREIGN_ACQUIRED_IN_DOMESTIC_MARKET_NO_NATIONAL_SIMILAR_CAMEX',
  NATIONAL_CONTENT_IMPORTATION_70 = 'NATIONAL_CONTENT_IMPORTATION_70',
}

export enum TaxCouponItemIcmsCst {
  TRIBUTED_FULLY = 'TRIBUTED_FULLY',
  EXEMPT = 'EXEMPT',
  TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION = 'TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION',
  CSOSN_OTHERS = 'CSOSN_OTHERS',
}

export enum TaxCouponItemPisCst {
  TAXABLE_OPERATION_NORMAL_RATE = 'TAXABLE_OPERATION_NORMAL_RATE',
  TAXABLE_OPERATION_DIFFERENTIATED_RATE = 'TAXABLE_OPERATION_DIFFERENTIATED_RATE',
  TAXABLE_OPERATION_QUANTITY_RATE = 'TAXABLE_OPERATION_QUANTITY_RATE',
  TAXABLE_OPERATION_MONOPHASIC = 'TAXABLE_OPERATION_MONOPHASIC',
  TAXABLE_OPERATION_SUBSTITUTION = 'TAXABLE_OPERATION_SUBSTITUTION',
  TAXABLE_OPERATION_ZERO_RATE = 'TAXABLE_OPERATION_ZERO_RATE',
  EXEMPT_OPERATION = 'EXEMPT_OPERATION',
  NON_INCIDENCE_OPERATION = 'NON_INCIDENCE_OPERATION',
  OPERATION_WITH_SUSPENSION = 'OPERATION_WITH_SUSPENSION',
  OTHER_OUTPUT_OPERATIONS = 'OTHER_OUTPUT_OPERATIONS',
  OPERATION_WITH_INTERNAL_TAX_CREDIT = 'OPERATION_WITH_INTERNAL_TAX_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT',
  PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED = 'PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED',
  PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE = 'PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE',
  PRESUMED_CREDIT_EXPORT_REVENUE = 'PRESUMED_CREDIT_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE',
  PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE',
  OTHER_PRESUMED_CREDITS = 'OTHER_PRESUMED_CREDITS',
  ACQUISITION_WITHOUT_CREDIT = 'ACQUISITION_WITHOUT_CREDIT',
  ACQUISITION_WITH_EXEMPTION = 'ACQUISITION_WITH_EXEMPTION',
  ACQUISITION_WITH_SUSPENSION = 'ACQUISITION_WITH_SUSPENSION',
  ACQUISITION_WITH_ZERO_RATE = 'ACQUISITION_WITH_ZERO_RATE',
  ACQUISITION_WITHOUT_INCIDENCE = 'ACQUISITION_WITHOUT_INCIDENCE',
  ACQUISITION_WITH_SUBSTITUTION = 'ACQUISITION_WITH_SUBSTITUTION',
  OTHER_INPUT_OPERATIONS = 'OTHER_INPUT_OPERATIONS',
  OTHER_OPERATIONS = 'OTHER_OPERATIONS',
}

export enum TaxCouponItemIssqn {
  DEMANDABLE = 'DEMANDABLE',
  NON_INCIDENCE = 'NON_INCIDENCE',
  EXEMPTION = 'EXEMPTION',
  EXPORT = 'EXPORT',
  IMMUNITY = 'IMMUNITY',
  DEMAND_SUSPENDED_JUDICIAL_DECISION = 'DEMAND_SUSPENDED_JUDICIAL_DECISION',
  DEMAND_SUSPENDED_ADMINISTRATIVE_PROCESS = 'DEMAND_SUSPENDED_ADMINISTRATIVE_PROCESS',
  TAXABLE_WITHIN_CITY = 'TAXABLE_WITHIN_CITY',
  TAXABLE_OUTSIDE_CITY = 'TAXABLE_OUTSIDE_CITY',
}

export enum TaxCouponItemCofinsCst {
  TAXABLE_OPERATION_NORMAL_RATE = 'TAXABLE_OPERATION_NORMAL_RATE',
  TAXABLE_OPERATION_DIFFERENTIATED_RATE = 'TAXABLE_OPERATION_DIFFERENTIATED_RATE',
  TAXABLE_OPERATION_QUANTITY_RATE = 'TAXABLE_OPERATION_QUANTITY_RATE',
  TAXABLE_OPERATION_MONOPHASIC = 'TAXABLE_OPERATION_MONOPHASIC',
  TAXABLE_OPERATION_SUBSTITUTION = 'TAXABLE_OPERATION_SUBSTITUTION',
  TAXABLE_OPERATION_ZERO_RATE = 'TAXABLE_OPERATION_ZERO_RATE',
  EXEMPT_OPERATION = 'EXEMPT_OPERATION',
  NON_INCIDENCE_OPERATION = 'NON_INCIDENCE_OPERATION',
  OPERATION_WITH_SUSPENSION = 'OPERATION_WITH_SUSPENSION',
  OTHER_OUTPUT_OPERATIONS = 'OTHER_OUTPUT_OPERATIONS',
  OPERATION_WITH_INTERNAL_TAX_CREDIT = 'OPERATION_WITH_INTERNAL_TAX_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE_CREDIT',
  OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT = 'OPERATION_WITH_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE_CREDIT',
  PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED = 'PRESUMED_CREDIT_INTERNAL_REVENUE_TAXED',
  PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE = 'PRESUMED_CREDIT_INTERNAL_NON_TAXABLE_REVENUE',
  PRESUMED_CREDIT_EXPORT_REVENUE = 'PRESUMED_CREDIT_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_REVENUE',
  PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE = 'PRESUMED_CREDIT_NON_TAXABLE_INTERNAL_AND_EXPORT_REVENUE',
  PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE = 'PRESUMED_CREDIT_TAXED_AND_NON_TAXABLE_INTERNAL_EXPORT_REVENUE',
  OTHER_PRESUMED_CREDITS = 'OTHER_PRESUMED_CREDITS',
  ACQUISITION_WITHOUT_CREDIT = 'ACQUISITION_WITHOUT_CREDIT',
  ACQUISITION_WITH_EXEMPTION = 'ACQUISITION_WITH_EXEMPTION',
  ACQUISITION_WITH_SUSPENSION = 'ACQUISITION_WITH_SUSPENSION',
  ACQUISITION_WITH_ZERO_RATE = 'ACQUISITION_WITH_ZERO_RATE',
  ACQUISITION_WITHOUT_INCIDENCE = 'ACQUISITION_WITHOUT_INCIDENCE',
  ACQUISITION_WITH_SUBSTITUTION = 'ACQUISITION_WITH_SUBSTITUTION',
  OTHER_INPUT_OPERATIONS = 'OTHER_INPUT_OPERATIONS',
  OTHER_OPERATIONS = 'OTHER_OPERATIONS',
}
